exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleBlue{font:var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) 45px/60px var(--unnamed-font-family-segoe-ui);letter-spacing:var(--unnamed-character-spacing-0);text-align:center;font:normal normal 700 2.3em Segoe UI;letter-spacing:0;color:#635bff;opacity:1;margin:auto}", ""]);

// exports
